import Attendance from './mainSection/svg/new/Attendance';
import Contracts from './mainSection/svg/new/Contracts';
import { HrmDualToneTitle } from './HrmDualToneTitle';

export function HrmIntegratedManagement({
    title,
    description,
    icon,
}: {
    title: string;
    description: string;
    icon?: string;
}) {
    return (
        <section className="lg:my-[60px] md:my-[40px] sm:my-[30px] my-[20px] shadow-sm rounded-lg p-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-center">
                <div className="flex justify-center lg:justify-start motion-safe:animate-float">
                    {icon === 'attendance' ? <Attendance /> : <Contracts />}
                </div>

                <div className="lg:col-span-2 col-span-1 flex flex-col justify-center lg:p-0 p-4">
                    <HrmDualToneTitle title={title} />
                    <p className="mt-6 text-primary-text/90 font-medium  sm:text-base text-[15px] lg:text-[20px] leading-relaxed pl-6 ml-auto">
                        {description}
                    </p>
                </div>
            </div>
        </section>
    );
}
